import React from 'react';
import { Typography } from '@equinor/opt-ui-core';
import { Block, Container, ScrollableContent } from 'Widgets/ui';
// Component
const SystemAvailabilityPage = () => (React.createElement(Container, null,
    React.createElement(ScrollableContent, null,
        React.createElement(Block, { maxWidth: "1080px", margin: "40px auto", textAlign: "center", px: "20px" },
            React.createElement(Block, null,
                React.createElement(Typography, { variant: "h2" }, "System Availability"),
                React.createElement(Typography, { mt: "30px" }, "Coming soon!"))))));
export default SystemAvailabilityPage;
